import React from 'react';
import { Box, Grid, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LayoutContainer from './LayoutWrapper';

const Footer = () => {
    const { logo, address, email } = useSelector((state) => state.shop);
    return (
        <Box sx={{ bgcolor: '#f2f8fc' }}>
            <LayoutContainer sx={{ mt: 6, pt: 4, px: { xs: 2, md: 10 }, fontSize: 14 }}>
                <Grid container spacing={4} sx={{ display: 'flex' }}>
                    {/* Logo + Info (4 phần) */}
                    <Grid item xs={12} sx={{ flexGrow: 4 }}>
                        <Box sx={{ mb: 2 }}>
                            {logo ? <img src={logo} alt="Logo" style={{ width: 120 }} /> : <Typography sx={{
                                fontFamily: 'Chakra Petch, sans-serif',
                                fontWeight: 600,
                                fontSize: '1.5rem',
                                letterSpacing: '1px',
                                textTransform: 'uppercase',
                            }}>{window.location.hostname.toLocaleUpperCase()}</Typography>}
                        </Box>
                        <Typography variant="body2" sx={{ mb: 1 }} ><b>Address:</b> {address}</Typography>
                        <Typography variant="body2" sx={{ mb: 1 }} ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
                        <Typography variant="body2" sx={{ mb: 1 }} ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
                    </Grid>

                    {/* Company (2 phần) */}
                    <Grid item xs={12} sx={{ flexGrow: 2 }}>
                        <Typography sx={{ fontWeight: 'bold', mb: 2 }}>Company</Typography>
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/about" underline="hover" color="inherit">About Us</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/order-tracking" underline="hover" color="inherit">Order Tracking</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/intellectual-property" underline="hover" color="inherit">Intellectual Property Claim</MuiLink>
                    </Grid>

                    {/* Policies (3 phần) */}
                    <Grid item xs={12} sx={{ flexGrow: 3 }}>
                        <Typography sx={{ fontWeight: 'bold', mb: 2 }}>Policies</Typography>
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/shipping" underline="hover" color="inherit">Shipping & Delivery</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/returns" underline="hover" color="inherit">Returns & Refund Policy</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/disclaimer" underline="hover" color="inherit">Disclaimer</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/privacy" underline="hover" color="inherit">Privacy Policy</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/terms" underline="hover" color="inherit">Terms Of Service</MuiLink>
                    </Grid>

                    {/* Services (3 phần) */}
                    <Grid item xs={12} sx={{ flexGrow: 3 }}>
                        <Typography sx={{ fontWeight: 'bold', mb: 2 }}>Services</Typography>
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/contact" underline="hover" color="inherit">Contact</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/faqs" underline="hover" color="inherit">Frequently Asked Questions (FAQs)</MuiLink><br />
                        <MuiLink component={Link} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ mb: 1, display: 'inline-block' }} to="/payment-methods" underline="hover" color="inherit">Payment Methods</MuiLink>
                    </Grid>
                </Grid>

                {/* Bottom line */}
                <Box sx={{
                    borderTop: '1px solid #ccc',
                    mt: 4,
                    py: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                }}>
                    <Typography variant="body2" sx={{ color: '#555' }}>
                        Copyright © <b>{window.location.hostname.split('.')[0]}</b> Store. All rights reserved
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <img src="/src/payments.png" alt="Payments" height={24} />
                    </Box>
                </Box>
            </LayoutContainer>
        </Box>
    );
};

export default Footer;
